import Api from "@/services/api";
import { DesignButtonStyle, CopyStyle } from "@/services/styles/types";

export async function getAllDesignButtonStyles(): Promise<Array<DesignButtonStyle>> {
    return new Promise((resolve, reject) => {
        Api.get("/designButtonStyles").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getDesignButtonStyle(id: string): Promise<DesignButtonStyle> {
    return new Promise((resolve, reject) => {
        Api.get(`/designButtonStyles/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createDesignButtonStyle(model: DesignButtonStyle): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/designButtonStyles", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateDesignButtonStyle(model: DesignButtonStyle): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/designButtonStyles", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteDesignButtontyle(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/designButtonStyles/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function copyDesignButtonStyle(model: CopyStyle): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/designButtonStyles/copy", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
